const cabData = [
  {
    name: "Maya Taxi",
    Contact: "416 222 4455",
    webPage: "https://www.mayacalltaxi.com/",
    reviews: "3.4/5 of 900+ reviews",
  },
  {
    name: "Fast Track Call Taxi",
    Contact: "416 288 8999",
    webPage: "https://vellore.fasttrackcalltaxi.in/",
    reviews: "4.5/5 of 800+ reviews",
  },
  {
    name: "Red Taxi",
    Contact: "Red taxi app",
    webPage: "https://www.redtaxi.co.in/",
    reviews: "4.8/5 of 500+ reviews",
  },
  {
    name: "Vellore Taxi Service",
    Contact: "958 553 3340",
    webPage: "https://www.velloretaxiservice.in/",
    reviews: "4.9/5 of 200+ reviews",
  },
  {
    name: "Call Taxi Vellore",
    Contact: "962 679 8689",
    webPage: "https://www.calltaxivellore.com/",
    reviews: "4.8/5 of 350+ reviews",
  },
];

export default cabData;
